import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { initStore } from '@/store'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'

const CategoryCard = (params) => {
  const setId = (id: number, name: string) => {
    initStore().ConfigStore.setCategoryId(id)
    eventLogProducer.push({
      action: Action.CATEGORYLINKCLICK,
      extra: { categoryName: name },
    })
  }
  return (
    <BannerBox>
      <div className="category-hook">
        {params.category?.map((item, index) => {
          return item.checked ? (
            <h2 className={'category checked'} key={index}>
              <span className={'category-text'} dangerouslySetInnerHTML={{ __html: item.name }}></span>
            </h2>
          ) : (
            <Link href={`/education-category/${item.slug}`} key={index}>
              <a className={'category'} onClick={() => setId(item.id, item.name)}>
                <p className={'category-text'} dangerouslySetInnerHTML={{ __html: item.name }}></p>
              </a>
            </Link>
          )
        })}
      </div>
    </BannerBox>
  )
}

export default CategoryCard

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .category-hook {
      padding-bottom: 20px;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      .category {
        white-space: nowrap;
        display: inline-block;
        padding-right: 20px;
        color: #757575;
        .category-text {
          font-size: 14px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
        }
      }
      .checked {
        color: #1cc812;
        display: inline;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-height: 420px;
    overflow-y: auto;
    .category-hook {
      background: #fff;
      padding: 10px 28px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .category {
        width: 100%;
        color: #757575;
        padding: 10px 0;
        .category-text {
          font-size: 16px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
        }
      }
      .checked {
        color: #1cc812;
      }
    }
  }
`
